import React, { useEffect, useState } from "react";
import ConfigData from "../../master/components/ConfigData";
import { AssetStatusList, AddEditAssetStatus, assetStatusObj } from "../component";
import { Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, } from "@material-ui/core";
import { EmptyCollection, ExportMenu, FilterComponent, Pagination, DeletePopUp, PageLoader, STableLoader } from "../../../shared_elements";
import { globalDeleteService, globalGetService, } from "../../../../globalServices";
import { checkApiStatus, } from "../../../utils_v2";
import { Link, withRouter } from 'react-router';
import { trackActivity } from "../../../../utils/mixpanel";
import { useSnackbar } from "notistack";
import AddIcon from '@material-ui/icons/Add';

const AssetStatusHeader = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell> Action(s) </TableCell>
                <TableCell> Ownership </TableCell>
                <TableCell> Asset Status </TableCell>
                <TableCell> Sub Status </TableCell>
                <TableCell> Contract Status </TableCell>
                <TableCell> Created By </TableCell>
                <TableCell> Last Updated By </TableCell>
                <TableCell style={{ minWidth: "140px", maxWidth: "200px" }}> Remarks </TableCell>
            </TableRow>
        </TableHead>
    )
}
const AssetStatus = ({ }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [deleteAssetStatus, setDeleteAssetStatus] = useState({ modal: false, data: null });
    const [assetStatusCRU, setAssetStatusCRU] = useState({ modal: false, data: null, type: '' });
    const [assetStatusInfo, setAssetStatusInfo] = useState({ list: [], pagination: {} });

    useEffect(() => {
        getAssetStatus({ per_page: 50 }, "skeletonLoader");
    }, [])


    const getAssetStatus = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`config-data/asset-status/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setAssetStatusInfo(response.data.data)
                    if (query) {
                        delete query.page
                        delete query.per_page
                        delete query.sort
                        delete query.sort_by
                        setFilter(query)
                    }
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }

    const onDelete = () => {
        setLoading(true)
        globalDeleteService(`config-data/asset-status/${deleteAssetStatus.data.id}`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setLoading(false)
                    setDeleteAssetStatus({ modal: false, data: null });
                    getAssetStatus({ ...filter, page: assetStatusInfo?.pagination?.page, per_page: assetStatusInfo?.pagination?.per_page }, 'pageLoader');
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Asset Status',
                        event_type: `Item Deleted`,
                        event_desc: 'Asset Status Deleted Successfully',
                        success_msg: response?.data?.message,
                        deleted_id: deleteAssetStatus.data.id
                    });
                } else {
                    setDeleteAssetStatus({ modal: false, data: null });
                    setLoading(false)
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Asset Status',
                        event_type: `Item Deleted`,
                        event_desc: 'Asset Status Deletion Failed',
                        error_msg: response?.data?.message,
                        deleted_id: deleteAssetStatus.data.id
                    });
                }
            });
    };
    let filterOption = {
        'search': {
            'inputType': 'text',
            'title': 'Asset Status',
        },
    }; 
    return (
        <section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
            <Paper elevation={1} className="tech-specs-card" style={{ height: `${window.innerHeight - 90}px` }}>
                 <ConfigData />
                <div className="tech-specs-content">
                    {skeletonLoader ? <STableLoader count={6} /> :
                        <div style={{ padding: '10px' }}>
                            <Paper square style={{ padding: '4px 8px' }}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item md={6}>
                                        <FilterComponent
                                            filter={filter}
                                            filterMenu={filterOption}
                                            getResponseBack={(applyFilter) => { getAssetStatus({ ...applyFilter, page: 1, per_page: assetStatusInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
                                        />
                                    </Grid>
                                    <Grid item md={6}>
                                        <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                            <li className='list-inline-item'>
                                                <Button onClick={() => setAssetStatusCRU({ modal: true, data: assetStatusObj, type: 'add' })} color="primary" size='small' variant="contained"> <AddIcon style={{fontSize:'1.15rem', marginInlineEnd:"2px"}}/>ADD</Button>
                                            </li>
                                        </ul>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper style={{ maxHeight: `${window.innerHeight - 210}px`, overflow: 'auto' }}>
                                <Table className='mui-table-format' stickyHeader>
                                    <AssetStatusHeader />
                                    <TableBody>
                                        {(() => {
                                            const list = assetStatusInfo?.list || [];
                                            if (!list.length) return null;
                                            const groups = {};
                                            const ownershipOrder = [];
                                            list.forEach(item => {
                                                const own = item?.ownership || 'Unknown';
                                                const ast = item?.asset_status || '';
                                                if (!groups[own]) { groups[own] = {}; ownershipOrder.push(own); }
                                                if (!groups[own][ast]) groups[own][ast] = [];
                                                groups[own][ast].push(item);
                                            });
                                            return ownershipOrder.map(ownership => [
                                                <TableRow key={`grp-${ownership}`}>
                                                    <TableCell
                                                        colSpan={8}
                                                        style={{
                                                            background: ownership === 'Owned' ? '#e8eaf6' : '#e3f2fd',
                                                            fontWeight: 700,
                                                            color: '#1a1c3a',
                                                            textTransform: 'uppercase',
                                                            letterSpacing: 1,
                                                            fontSize: 13,
                                                            padding: '8px 16px',
                                                        }}
                                                    >
                                                        {ownership === 'Owned' ? '🔷' : '🔹'} {ownership}
                                                    </TableCell>
                                                </TableRow>,
                                                ...Object.keys(groups[ownership]).map(assetStatus => [
                                                    <TableRow key={`sub-${ownership}-${assetStatus}`}>
                                                        <TableCell
                                                            colSpan={8}
                                                            style={{
                                                                background: '#f5f6fa',
                                                                color: '#6b7280',
                                                                fontStyle: 'italic',
                                                                paddingLeft: 32,
                                                                fontSize: 13,
                                                                borderBottom: '1px solid #e5e7eb',
                                                            }}
                                                        >
                                                            {assetStatus}
                                                        </TableCell>
                                                    </TableRow>,
                                                    ...groups[ownership][assetStatus].map((item, index) => (
                                                        <AssetStatusList
                                                            key={item?.id || `${ownership}-${assetStatus}-${index}`}
                                                            item={item}
                                                            onDelete={setDeleteAssetStatus}
                                                            onEditFn={() => setAssetStatusCRU({ modal: true, data: item, type: 'edit' })}
                                                            onViewFn={() => setAssetStatusCRU({ modal: true, data: item, type: 'view' })}
                                                        />
                                                    )),
                                                ]),
                                            ]);
                                        })()}
                                    </TableBody>
                                </Table>
                            </Paper>
                            <Paper>
                                <Pagination
                                    pagination={assetStatusInfo?.pagination}
                                    onChangePage={(event, newPage) => { getAssetStatus({ ...filter, page: newPage + 1, per_page: assetStatusInfo.pagination?.per_page}, 'pageLoader');}}
                                    onChangeRowsPerPage={(event) => getAssetStatus({ ...filter, page: 1, per_page: event.target.value,}, 'pageLoader')}
                                />
                            </Paper>
                            <Paper>
                                {!assetStatusInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                            </Paper>
                        </div>}
                </div>
                {assetStatusCRU?.modal ?
                    <AddEditAssetStatus
                        assetStatusCRU={assetStatusCRU}
                        assetStatusInfo={assetStatusInfo}
                        toggleModalFn={() => setAssetStatusCRU({ modal: false, apuTypesData: [] })}
                        getResponseBack={() => getAssetStatus({ ...filter, page: assetStatusInfo?.pagination?.page, per_page: assetStatusInfo?.pagination?.per_page }, 'pageLoader')}
                        modeType={assetStatusCRU?.type}
                    /> : null
                }
                <DeletePopUp
                    modal={deleteAssetStatus.modal}
                    title='Delete Asset Status'
                    content={`Are you sure, you want to Delete?`}
                    toggleModalFn={() => setDeleteAssetStatus({ modal: false, data: null })}
                    deleteRecordFn={onDelete}
                />
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </section >
    )
}

export default withRouter(AssetStatus);
